export default __webpack_public_path__ + "static/media/ISO 37001 2025_IT345302   - FINCANTIERI SI S.P.A ing.881fbfa0.pdf";